export default function ThemeResult(result, customButtonDefs, extraButtonDefs, options) {
  const searcher = result.searcher;
  if (result.searcher && jQuery.isFunction(searcher.themeResult)) {
    return searcher.themeResult(result);
  } else {
    let output;
    if (options && options.format == "compact") {
      output = jQuery("<div class='ssResult ssCompactResult'/>");

      output = output.append('<div class="ssResultTitle" title="' + result.title + '">' + result.title + '</div>');
      output = output.append(createCustomButtons(result, customButtonDefs, extraButtonDefs));

    } else {
      output = jQuery("<div class='ssResult'/>");

      if (result.hasOwnProperty("image") && result.image !== null && result.image !== "" && !(typeof options !== 'undefined' && options.format === "noimage")) {
        output = output.append('<div class="ssResultImage"><img src="' + result.image + '"></div>');
      } else {
        output = output.append('<div class="ssResultImage"></div>');
      }


      if (result.hasOwnProperty("description") && result.description !== null) {
        let title = result.title + '\n' + result.description.replace(/<(?:.|\n)*?>/gm, ' ');
        output.append('<div class="ssResultTitle" title="'+ title + '">' + result.title + '<span class="ssResultDescription" >' + result.description + '</span></div>');
      } else {
        output.append('<div class="ssResultTitle" title="'+ result.title + '">' + result.title + '</div>');
      }
			
      output = output.append(createCustomButtons(result, customButtonDefs, extraButtonDefs));
    }
    return output;
  }
}

export function createCustomButtons(result, customButtonDefs, extraButtonDefs, options) {
  let createFunction = createButton;
  let customButtonCount = 0;
  let extraButtonCount = 0;
  if (options && options.format === "list") {
    createFunction = createIconAndText;
  }
  const buttonsContainer = jQuery("<div class='ssButtonsContainer'/>");
  let custombuttons = jQuery("<div class='ssCustomButtons'/>");
  if (customButtonDefs !== undefined && result.searcher) {
    customButtonCount = customButtonDefs.length;
    for (let i = 0; i < customButtonDefs.length; i++) {
      let button = createFunction(result, customButtonDefs[i]);
      button.addClass("ssCustombutton");
      custombuttons = custombuttons.append(button);
    }
  }
  let extrabuttons = jQuery("<div class='ssExtraButtons'/>");
  if (extraButtonDefs !== undefined) {
    extraButtonCount += extraButtonDefs.length;
    for (let j = 0; j < extraButtonDefs.length; j++) {
      let extraButtonDef = extraButtonDefs[j];
      let button = createFunction(result, extraButtonDef);
      button.addClass("ssExtraButton");
      extrabuttons = extrabuttons.append(button);
    }
  }
  buttonsContainer.addClass("buttoncount" + (customButtonCount + extraButtonCount));
  custombuttons.addClass("buttoncount" + customButtonCount);
  extrabuttons.addClass("buttoncount" + extraButtonCount);
	
  buttonsContainer.append(custombuttons);
  buttonsContainer.append(extrabuttons);
  return buttonsContainer;
}

export function createIconAndText(result, buttonDef) {

  const button = jQuery('<div/>');
  if (buttonDef.buttonImage !== undefined) {
    button.append(jQuery("<img title='" + buttonDef.buttonText + "' src = '" + buttonDef.buttonImage + "'/>"));
  }
  button.append(jQuery("<span>" + buttonDef.buttonText + "</span>"));
  if (buttonDef.callBack) {
    let callBack = buttonDef.callBack;
    button.click(()=>{
      callBack(result);
      return false;
    });
  }
  return button;
}

export function createButton(result, buttonDef) {

  let button = null;
  if (buttonDef.buttonImage === undefined) {
    button = jQuery('<span class="ssButton"></span>');
    button.append(buttonDef.buttonText);
  } else {
    button = jQuery("<img title='" + buttonDef.buttonText + "' src = '" + buttonDef.buttonImage + "'/>");
  }
  if (buttonDef.callBack) {
    let callBack = buttonDef.callBack;
    button.click(()=>{
      let newButtonDef = callBack(result);
      if (typeof newButtonDef !== 'undefined' && newButtonDef !== null) {
        if (newButtonDef.buttonImage === undefined) {
          button.empty();
          button.append(newButtonDef.buttonText);
        } else {
          button.attr("src", newButtonDef.buttonImage);
          button.attr("title", newButtonDef.buttonText);
        }
      }
      return false;
    });
  }
  return button;
}
